/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < Codebhendi, Ravi Ranjan Kumar, Sanket, Mylavarapu Sarath Sai, Amal Sabu, Ujjwal Singh >

*/
import React, {
  useState,
  useEffect,
  // Suspense,
  lazy,
} from "react";
import { Switch, Redirect } from "react-router-dom";
import useVerifyLogin from "Hooks/verify-login";

import { RouteWithLayout } from "./components";
import { Main as MainLayout, Minimal as MinimalLayout } from "./layouts";
import { connect } from "react-redux";
import ReportLayout from "views/view-images/pdfReport/ReportLayout";
import BuReportLayout from "views/View-patients-bu/components/ReportLayout";
import { isFeatureEnabled, isMlEntitlementEnabled } from "realtime/entitlementMode";
// dynamic import code split
const UserListView = lazy(() => import("views/UserList"));
const AccountView = lazy(() => import("views/Account"));
const SettingsView = lazy(() => import("views/Settings"));
const SignUpView = lazy(() => import("views/SignUp"));
const SignInView = lazy(() => import("views/SignIn"));
const NotFoundView = lazy(() => import("views/NotFound"));
const addPatient = lazy(() => import("views/add-patient"));
const addVisitId = lazy(() => import("views/visitId"))
const ViewReport = lazy(() => import("views/Report"));
const BulkImageUpload = lazy(() => import("views/Bulk-upload"));
const ViewImages = lazy(() => import("views/view-images"));
const ReviewPatient = lazy(() => import("views/Review-patient"));
const BulkImageReport = lazy(() =>
  import("views/Bulk-upload/bulk-report-data-print")
);
const ForgetPassword = lazy(() =>
  import("views/ResetPassword/forget-password")
);
const ResetPassword = lazy(() => import("views/ResetPassword/reset-password"));
const ViewPatient = lazy(() => import("views/view-patient/ViewPatient"));
const ReviewImages = lazy(() => import("views/Review-Images/ReviewImages"));
const DoctorAnnotationPatient = lazy(() =>
  import("views/Doctor-Annotation-Patient")
);
const ViewPatientBu = lazy(() =>
  import("views/View-patients-bu/ViewPatientsBu")
);

const Routes = ({ userLoggedIn, isCurrentUserAConsultant, orgzFeatures,noAiAnnotation }) => {
  const {
    bulk_upload: isBulkUploadActive,
    bulk_upload_for_patient: isBulkUploadForPatientActive,
    doc_annotation_patient: isDocAnnotationPatientActive,
    patient_upload: ispatientUploadActive,
    report_download: isReportDownloadActive,
    report_share: isReportShareActive,
    review_images: isReviewImagesActive,
    review_patients: isReviewPatientsActive,
    trigger_review_for_image: isTriggerReviewForImageActive,
    trigger_review_for_patient: isTriggerReviewForPatientActive,
    view_images: isViewImagesActive,
    view_patient: isViewPatientActive,
    view_patients_from_bulk_upload: isViewPatientsFromBulkUploadActive,
  } = orgzFeatures;

  const login = userLoggedIn || useVerifyLogin();
  if (!login) {
    return (
      <Switch>
        <Redirect exact from="/" to={"/sign-in"} />
        <RouteWithLayout
          component={SignUpView}
          exact
          layout={MinimalLayout}
          path="/sign-up"
        />
        <RouteWithLayout
          component={SignInView}
          exact
          layout={MinimalLayout}
          path="/sign-in"
        />
        <RouteWithLayout
          component={ForgetPassword}
          exact
          layout={MinimalLayout}
          path="/forget-password"
        />
        <RouteWithLayout
          component={ResetPassword}
          exact
          layout={MinimalLayout}
          path="/reset-password"
        />
        <RouteWithLayout component={NotFoundView} layout={MinimalLayout} />
      </Switch>
    );
  }

  if (isCurrentUserAConsultant) {
    return (
      <Switch>
        <Redirect exact from="/" to={"/sign-in"} />
        <RouteWithLayout
          component={SignUpView}
          exact
          layout={MinimalLayout}
          path="/sign-up"
        />
        <RouteWithLayout
          component={SignInView}
          exact
          layout={MinimalLayout}
          path="/sign-in"
        />
        <RouteWithLayout
          component={ForgetPassword}
          exact
          layout={MinimalLayout}
          path="/forget-password"
        />
        <RouteWithLayout
          component={ResetPassword}
          exact
          layout={MinimalLayout}
          path="/reset-password"
        />
        <RouteWithLayout
          component={DoctorAnnotationPatient}
          exact
          layout={MainLayout}
          path="/doctor-review"
        />
        <RouteWithLayout component={NotFoundView} layout={MinimalLayout} />
      </Switch>
    );
  }

  return (
    <Switch>
      <Redirect exact from="/" to={"/sign-in"} />
      {isCurrentUserAConsultant ? (
        <RouteWithLayout
          component={DoctorAnnotationPatient}
          exact
          layout={MainLayout}
          path="/doctor-review"
        />
      ) : (
        ispatientUploadActive && (
          <RouteWithLayout
            component={UserListView}
            exact
            layout={MainLayout}
            path="/patients"
          />
        )
      )}
      {ispatientUploadActive && (
        <RouteWithLayout
          component={addPatient}
          exact
          layout={MainLayout}
          path="/patients/add-patient"
        />
      )}
       {ispatientUploadActive && (
        <RouteWithLayout
          component={addVisitId}
          exact
          layout={MainLayout}
          path="/patients/add-visitID"
        />
      )}
      {ispatientUploadActive && (
        <RouteWithLayout
          component={addPatient}
          exact
          layout={MainLayout}
          path="/patients/update-patient/:id"
        />
      )}
      {ispatientUploadActive && (
        <RouteWithLayout
          component={addPatient}
          exact
          layout={MainLayout}
          path="/view-patients/update-patient/:id"
        />
      )}
      {isReportShareActive && (
        <RouteWithLayout
          component={ViewReport}
          exact
          layout={MinimalLayout}
          path="/view-report/:id"
        />
      )}
      <RouteWithLayout
        component={ViewReport}
        exact
        layout={MinimalLayout}
        path="/view-patient-report/:id"
      />
      {/* Disabled profile/account page at request of Ms.Amruta. */}
      {/* <RouteWithLayout
        component={AccountView}
        exact
        layout={MainLayout}
        path="/account"
      /> */}
      {isViewPatientActive && (
        <RouteWithLayout
          component={ViewPatient}
          exact
          layout={MainLayout}
          path="/view-patients"
        />
      )}
      {(isFeatureEnabled(isBulkUploadActive) || isFeatureEnabled(isBulkUploadForPatientActive)) &&
        isMlEntitlementEnabled(noAiAnnotation) && (
        <RouteWithLayout
          component={BulkImageUpload}
          exact
          layout={MainLayout}
          path="/bulk-upload"
        />
      )}

      {isViewImagesActive && (
        <RouteWithLayout
          component={ViewImages}
          exact
          layout={MainLayout}
          path="/view-images"
        />
      )}
      {isViewImagesActive && (
        <RouteWithLayout
          component={ReportLayout}
          exact
          layout={MainLayout}
          path="/view-images/report"
        />
      )}
      {isMlEntitlementEnabled(noAiAnnotation) && (
        <RouteWithLayout
          component={BulkImageReport}
          exact
          layout={MinimalLayout}
          path="/bulk-upload-reports"
        />
      )}
      <RouteWithLayout
        component={SettingsView}
        exact
        layout={MainLayout}
        path="/settings"
      />
      {isReviewPatientsActive && (
        <RouteWithLayout
          component={ReviewPatient}
          exact
          layout={MainLayout}
          path="/review-patients"
        />
      )}

      {isViewPatientsFromBulkUploadActive && (
        <RouteWithLayout
          component={ViewPatientBu}
          exact
          layout={MainLayout}
          path="/view-patients-bu"
        />
      )}
      {isViewPatientsFromBulkUploadActive && (
        <RouteWithLayout
          component={BuReportLayout}
          exact
          layout={MainLayout}
          path="/view-patients-bu/report"
        />
      )}

      {isReviewImagesActive && (
        <RouteWithLayout
          component={ReviewImages}
          exact
          layout={MainLayout}
          path="/review-images"
        />
      )}
      <RouteWithLayout
        component={SignUpView}
        exact
        layout={MinimalLayout}
        path="/sign-up"
      />
      <RouteWithLayout
        component={SignInView}
        exact
        layout={MinimalLayout}
        path="/sign-in"
      />
      <RouteWithLayout
        component={ForgetPassword}
        exact
        layout={MinimalLayout}
        path="/forget-password"
      />
      <RouteWithLayout
        component={ResetPassword}
        exact
        layout={MinimalLayout}
        path="/reset-password"
      />
      <RouteWithLayout component={NotFoundView} layout={MinimalLayout} />
      {/* <Redirect to="/not-found" /> */}
    </Switch>
  );
};
const mapStateToProps = (state) => ({
  userLoggedIn: state.userStore?.userLoginRes?.success,
  isCurrentUserAConsultant:
    state.userStore?.userProfile?.consultantDetails?.isCurrentUserAConsultant,
  noAiAnnotation: state.userStore?.userProfile?.no_ai_annotation,
  orgzFeatures: state.globalStore?.orgzFeatures || {
    bulk_upload: 0,
    bulk_upload_for_patient: 0,
    doc_annotation_patient: 0,
    patient_upload: 0,
    report_download: 0,
    report_share: 0,
    review_images: 0,
    review_patients: 0,
    trigger_review_for_image: 0,
    trigger_review_for_patient: 0,
    view_images: 0,
    view_patient: 0,
    view_patients_from_bulk_upload: 0,
  },
});

export default connect(mapStateToProps)(Routes);
